import {Component} from '@angular/core';
import {Store} from '@ngrx/store';
import { IAppState } from 'app/IAppState';

@Component({
  selector: 'bz-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['alert.component.scss']
})
export class BzAlertComponent {

  public alerts: IBzAlertMessage[];

  constructor(
    private _store: Store<IAppState>
  ) {
    this.alerts = [];
    this._store
      .select((s)=>s.bzAlertState.alertMessages)
      .subscribe((value: IBzAlertMessage[]) => {
        this.alerts = value;
      });
  }

}
